import { PaginatedTable } from "components/Table/Table";
import { RULE_TABLE_COLUMNS } from "./RuleTableColumns";

import { Row } from "react-table";

import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Rule } from "interfaces/rule";

export interface SiteTableProps {
  loading: boolean;
  error: boolean;
  rules: Rule[];
  selectedRuleId: number;
  count: number;
  page: number;
  pageSize: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onChangePageSize: (pageSize: number) => void;

  onChangeSelectedRuleId: (ruleId: number) => void;
  onClickEdit: () => {};
}

export const NewRuleTable = ({
  loading,
  rules,
  selectedRuleId,
  count,
  page,
  pageSize,
  onPageChange,
  onChangeSelectedRuleId,
  onChangePageSize,
  onClickEdit
}: SiteTableProps): JSX.Element => {
  const handleOnClickRow = ({ original: rule }: Row<Rule>): void => {
    onChangeSelectedRuleId(rule.rule_id);
  };
  const columns = RULE_TABLE_COLUMNS({ onClickEdit });

  return (
    <SiteTableScroll elevation={0}>
      <PaginatedTable
        data={rules}
        columns={columns}
        loading={loading}
        dataQa="rules-table"
        count={count}
        page={page}
        pageSize={pageSize}
        onPageChange={onPageChange}
        onPageSizeChange={(
          event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
        ) => onChangePageSize(parseInt(event.target.value))}
        onSortingChange={() => {}}
        onClickRow={handleOnClickRow}
        isRowSelected={alert => alert.rule_id === selectedRuleId}
      />
    </SiteTableScroll>
  );
};

const SiteTableScroll = styled(Paper)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  border: 1px solid rgba(224, 224, 224, 1);
  border-radius: 4px;
`;
